import React, {Component} from 'react'
import PropTypes from 'prop-types'
import BasketItem from './BasketItem'

class BasketsList extends Component {
    render() {
        const {baskets, ...rest} = this.props

        return baskets.map(basket => <BasketItem key={basket._id} {...rest} basket={basket}/>)
    }
}

BasketsList.propTypes = {
    baskets: PropTypes.array.isRequired,
}

export default BasketsList
